module.exports = __webpack_public_path__ + "img/3_174.73d37b32.png";